import React, {useState} from 'react';
import './FAQs.css'

import img1 from "../../Images/Landing.jpg"

 


function Faqs() {


  const [PhylState,setPhlState] = useState(true)
  const [consist,setConsist] = useState(false)
  const [creative,setCreative] = useState(false)

  const phylHandler = ()=>{
           
       setPhlState(!PhylState);
       if(consist || creative){
        setConsist(false);
        setCreative(false)

       }
       
      console.log("phyl",PhylState)
      console.log("consist",consist)
      console.log("creat",creative)
  }

  const creativeHandler = ()=>{
           
    setCreative(!creative);
    if(consist || PhylState){
     setPhlState(false);
     setConsist(false)

    }
   
   console.log("phyl",PhylState)
   console.log("consist",consist)
   console.log("creat",creative)
}

const consistHandler = ()=>{
           
  setConsist(!consist);
  if(PhylState || creative){
   setPhlState(false);
   setCreative(false)

  }
 
 console.log("phyl",PhylState)
 console.log("consist",consist)
 console.log("creat",creative)
}


 



  return  <div className='FAQCover'>

              <div className='FAQHeading'>

                <h1>FAQs</h1>

           </div>


          <div className='Virtue'>  
    
      
        <div className='Virtues'>  


        <div className={PhylState ? "PhylState Active": "PhylState"} onClick={phylHandler}>  

                    <div className='subHeading'>
                              <div className='headTitle'>
                                        <h3>How are UNILUS Online courses delivered?</h3>
                              </div>

                              <div className='plusSign'>
                                        <h3>+</h3>
                              </div>

                              <div className='minusSign'>
                                        <h3>-</h3>
                              </div>
                                       
                    </div>
        <div className='VText'>  

        <p> 
        Our programs offer immersive, real-world learning bridging theory with practical application. Develop critical thinking and analytical skills while mastering tools across many domains. Our flexible structure fits into your busy life, balancing work, personal commitments, and professional growth effectively. With hands-on learning and flexible scheduling, our programs are tailored to today's professionals' realities.
        </p>
        </div>
       
        </div>

        <div className={consist? "Consist Active": "Consist"} onClick={consistHandler}>
        <div className='subHeading'>  
                  <div className='headTitle'>
                            <h3>
                                Do I need to come to campus to participate in UNILUS Online programs?
                            </h3>
                  </div>

                  <div className='plusSign'>
                            <h3>+</h3>
                  </div>

                  <div className='minusSign'>
                            <h3>-</h3>
                  </div>
                                   
                                   
        </div>
       
        <div className='VText' >
           <p>No, all of our programs are 100 percent online, and available to participants regardless of their location.</p>
        </div>

       
        </div>  

          <div className={creative? "Creative Active": "Creative"} onClick={creativeHandler}>  

                <div className='subHeading'>
                            <div className='headTitle'>
                                      <h3>What are my payment options?</h3>
                            </div>

                            <div className='plusSign'>
                                    <h3>+</h3>
                            </div>

                            <div className='minusSign'>
                                    <h3>-</h3>
                            </div>
                             
              </div>
                       
        <div className='VText' >  

           <p>We accept payments via Zanaco Bill Muster, Indo school fees Pay and Airtel money Bill Muster</p>
       
        </div>


          </div>

        </div>

     

         {/* <div className='vitueImage'>
                     <img src={img1} />

         </div> */}
     

  </div>

  </div>
  
  

}

export default Faqs;